<template>
  <div class="form-list">
    <el-form
      ref="form"
      :model="card"
      label-position="right"
      label-width="160px"
      class="form"
    >
      <div class="table-title table-title-top">退卡申请信息</div>
      <el-form-item v-if="card.add_time_apply" label="退卡申请时间">{{ card.add_time_apply | timeToYmdHi }}</el-form-item>

      <el-form-item v-if="card.admin_id_apply" label="退卡申请者">
        <v-avatar-nickname
          :value="card.admin_avatar_apply"
          :nickname="card.admin_nickname_apply"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="退卡门店">{{ card.store_name_refund }}</el-form-item>

      <div class="table-title">课卡信息</div>

      <div class="field-group-label">基础信息</div>

      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="card.selfie"
          :nickname="card.student_name"
          :is-center="false"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="card.student_id"
        />
      </el-form-item>

      <el-form-item label="课卡 ID">{{ card.card_id }}</el-form-item>

      <el-form-item label="课卡名称">{{ card.card_name }}</el-form-item>

      <el-form-item label="课卡类型">{{ card.card_type_name }}</el-form-item>

      <el-form-item v-show="card.is_number_limit" label="有效次数">
        <span class="primary-color">{{ card.expire_number }}</span> 次
      </el-form-item>

      <el-form-item label="有效天数">{{ card.expire_days }} 天</el-form-item>

      <el-form-item label="办卡日期">{{ card.register_time | timeToYmd }}</el-form-item>

      <el-form-item label="办卡门店">{{ card.store_name_card }}</el-form-item>

      <el-form-item label="失效日期">{{ card.expire_time | timeToYmdHi }}</el-form-item>

      <el-form-item label="实际付款">
        <span class="income-color">{{ card.actual_payment }}</span> 元
      </el-form-item>

      <div class="table-title">退卡信息</div>

      <el-form-item label="退款金额" prop="del_payment">
        <span class="pay-color">{{ card.del_payment }}</span> 元
      </el-form-item>

      <el-form-item label="退卡原因">
        <el-radio disabled v-model="card.is_input_error" :label="0">非录入错误</el-radio>
        <el-radio disabled v-model="card.is_input_error" :label="1">录入错误</el-radio>
        <div class="danger-color">{{ card.del_remark }}</div>
      </el-form-item>

      <el-form-item label="退卡原因截图">
        <v-img v-if="card.del_cover" :value="card.del_cover"/>
        <span v-else class="info-color">无</span>
      </el-form-item>

      <div class="table-title">审核信息</div>

      <el-form-item v-if="isAdministrator" label="退卡通过者">
        <v-avatar-nickname
          :value="card.admin_avatar"
          :nickname="card.admin_nickname"
          :is-center="false"
        />
      </el-form-item>

      <el-form-item label="退卡通过时间">{{ card.add_time | timeToYmdHi }}</el-form-item>

      <el-form-item>
        <el-button @click="RouteConfig.cardDeleteApplyList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { applyStates } from "@/enums/applyStates";
import { show } from "@/api/card-del-record";
import { toYuan } from "@/filters";

export default {
  name: RouteConfig.cardDeleteRecordDetail.name,
  data: () => ({
    RouteConfig,
    applyStates,
    isSaving: false,
    isPassing: false,
    isRejecting: false,
    isRevoking: false,
    isLoading: false,
    isLoadingError: false,
    card: {
      card_id: 0,
      add_time: 0,
      add_time_apply: 0,
      is_reviewing: 0,
      student_id: 0,
      selfie: '',
      student_name: '',
      add_store_name: '',
      card_name: '',
      card_type_name: '',
      expire_number: '',
      expire_days: '',
      register_time: '',
      expire_time: '',
      actual_payment: '',
      apply_state: applyStates.review.value,

      store_name_card: '',
      store_name_refund: '',

      admin_id_apply: 0,
      admin_nickname_apply: '',
      admin_avatar_apply: '',

      admin_id: 0,
      admin_nickname: '',
      admin_avatar: '',

      del_cover: '',
      del_payment: 0,
      del_remark: '',
      is_input_error: 0,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      if (data.expire_number) data.expire_number = toYuan(data.expire_number);
      if (data.actual_payment) data.actual_payment = toYuan(data.actual_payment);
      if (data.del_payment) data.del_payment = toYuan(data.del_payment);

      const { card } = this;
      const updateCardInfo = {};
      Object.keys(data).forEach(key => {
        if (key in card) updateCardInfo[key] = data[key];
      });
      Object.assign(card, updateCardInfo);
      this.isLoading = false;
    },
  },
};
</script>
<style src="./card-detail.css" scoped/>
